import React, { useState } from "react";
import { Button } from "antd";
import { Page } from "components/Page";
import { useGlobalContext } from "state/GlobalContext";
import { CardBox } from "page-components/CardBox";
import { ChargeDetails } from "page-components/ChargeDetails";
import { Box, Heading, Paragraph } from "theme-ui";
import { useNavigate } from "react-router-dom";
import { ShareModal } from "page-components/ShareModal";

const ConfirmationPage: React.FC = () => {
  const [{ state }] = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const onShare = () => {
    setIsOpen(true);
  }

  const extra = (
    <Button type="primary" onClick={() => navigate('/camp-site')}>Go back to camp site</Button>
  )

  return (
    <Page title="Confirmation" extra={extra} hideBack>
      <ShareModal isOpen={isOpen} setIsOpen={setIsOpen} />

      <CardBox md={14}>
        <Box my={3} sx={{textAlign: 'center'}}>
          <Heading>Your camp site is booked!</Heading>
          <p>
            Please check your email for the next steps
          </p>
          <Box mx="auto" my={40} sx={{width: 200}}>
            <Button type="primary" onClick={onShare}>Share reservation</Button>
          </Box>
        </Box>
        <img src="/assets/confirmation-bg.png" alt="bg" width="100%" />
      </CardBox>

      <CardBox md={10}>
        <ChargeDetails title="Payment detail" quote={state.quote} />
        <Paragraph sx={{fontSize: 1}} my={3}>
          *Total amount may not include applicable fees.<br/>
          Your balance will be due at check-in.<br/>
        </Paragraph>
      </CardBox>
    </Page>
  );
};

export default ConfirmationPage;
